var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m1.591 13.191a1.6 1.6 0 1 1 3.202-.017 1.6 1.6 0 0 1-3.202.017m3.279-6.826L8.365 16.87a.87.87 0 0 1-.617.252.868.868 0 0 1-.618-1.487l8.505-8.505a.874.874 0 0 1 1.235 1.235m-6.461.444a1.6 1.6 0 1 1-3.202.017 1.6 1.6 0 0 1 3.202-.017"
  })));
};
export default SvgDiscount;